import React from "react";
import { Box, Step, StepLabel, Stepper, StepperProps } from "@mui/material";
import { Check } from "@mui/icons-material";

type Props = StepperProps & {
  steps?: string[];
  activeStep: number;
};

const formSteps = ["物件概要の入力", "お客様情報の入力", "AI査定結果"];

const CustomStepper = ({ steps = formSteps, activeStep = 0 }: Props) => {
  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((label, index) => (
        <Step
          key={label}
          sx={{
            "& .MuiStepConnector-root": {
              top: 20,
            },
            "& .MuiStepConnector-line": {
              borderColor: "grey.300",
              borderTopWidth: "2px",
            },
          }}
        >
          <StepLabel
            slots={{
              stepIcon: (props) => (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    border: 2,
                    borderColor: !props.active ? "disabled.main" : "primary.main",
                    backgroundColor: props.completed ? "primary.main" : "white",
                    color: props.completed ? "white" : props.active ? "primary.main" : "grey.300",
                    dropShadow: "0 0 4px 0 #7A75BF80",
                  }}
                >
                  {props.completed ? <Check /> : String(index + 1).padStart(2, "0")}
                </Box>
              ),
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CustomStepper;
